module.exports = __webpack_public_path__ + "img/prato.fd80ecec.png";